module.exports = __webpack_public_path__ + "static/media/numerologyImage.e8025bc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/numerology/numerologyImage.png
// module id = 1478
// module chunks = 0